import { render, staticRenderFns } from "./CardProvider.vue?vue&type=template&id=290bcde8&scoped=true&"
import script from "./CardProvider.vue?vue&type=script&lang=js&"
export * from "./CardProvider.vue?vue&type=script&lang=js&"
import style0 from "./CardProvider.vue?vue&type=style&index=0&id=290bcde8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290bcde8",
  null
  
)

export default component.exports